import React, { useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Grid2,
  Typography,
  useTheme,
  Skeleton,
} from "@mui/material";
import { ArrowOutward } from "@mui/icons-material";
import { IoIosHappy } from "react-icons/io";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useGetProgressKpiQuery } from "store/slices/apis/pmDashboardSlice";
import PMPopup from "./PMPopup";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import ProjectStatusOverviewHead from "../../../../components/ProjectStatusOverviewHead";
import { ReactComponent as ArrowIcon } from "assets/PwC_Funct_Icons_ArrowIncrease_Outline_Black_RGB.svg"
import { ReactComponent as ArrowUpIcon } from "assets/PwC_Funct_Icons_ArrowUp_Outline_Black_RGB.svg"
import { ReactComponent as ArrowDownIcon } from "assets/PwC_Funct_Icons_ArrowDown_Outline_Black_RGB.svg"

const ProgressKpiPM = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const { data, isLoading } = useGetProgressKpiQuery({ projectId });
  //const { data:resp, error} = useGetUtilizationKpiQuery({projectId});


  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const kpiRaw = data?.data || {};
  //const utilize = resp?.data || {};


  const lastUpdated = data?.data?.lastUpdated;


  const kpiData = [
    {
      title: "Total Equipments",
      value: kpiRaw?.totalequipments ?? 0,
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
      color: "#9ED3CC",
    },
    {
      title: "Actual Available",
      value: kpiRaw?.actualavailable ?? 0,
      change: `${kpiRaw?.Actualavailablechange ?? 0}%`,
      isPositive: isLoading
        ? true
        : parseFloat(kpiRaw.actualavailablechange ?? 0) > 0
          ? true
          : false,
      arrow: `${parseFloat(kpiRaw.actualavailablechange ?? 0) >= 0 ? "up" : "down"
        }`,
      absoluteChange: `${Math.abs(kpiRaw?.actualavailablechange ?? 0)}%`,
      status: "ActualAvailable",
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      timeFrame: "this month",
      color: "#9ED3CC",
      hasStatus: true,
    },
    {
      title: "Equipment Utilisation",
      value: kpiRaw?.utilization ?? 0,
      change: `${kpiRaw?.utilizationchange ?? 0}%`,
      isPositive: isLoading
        ? true
        : parseFloat(kpiRaw?.utilizationchange ?? 0) > 0
          ? true
          : false,
      arrow: `${parseFloat(kpiRaw?.utilizationchange ?? 0) >= 0 ? "up" : "down"}`,
      absoluteChange: `${Math.abs(kpiRaw?.utilizationchange ?? 0)}%`,
      timeFrame: "this week",
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
      color: "#9ED3CC",
      hasStatus: true,
    },
    {
      title: "Average Idle Time",
      value: kpiRaw?.idletime ?? 0,
      isTime: true,
      change: kpiRaw?.idletimechange ?? 0,
      isPositive: isLoading ? true : parseFloat(kpiRaw?.idletimechange ?? 0) > 0 ? false : true,
      arrow: `${parseFloat(kpiRaw?.idletimechange ?? 0) >= 0 ? "up" : "down"}`,
      absoluteChange: `${Math.abs(kpiRaw?.idletimechange ?? 0)}%`,
      timeFrame: "this week",
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
      color: "#9ED3CC",
      hasStatus: true,
    },
    {
      title: "Breakdown Frequency Rate",
      value: kpiRaw?.breakdownfrequency ?? 0,
      change: kpiRaw?.breakdownfrequencychange ?? 0,
      isPositive: isLoading ? true : parseFloat(kpiRaw?.breakdownfrequencychange ?? 0) > 0 ? false : true,
      arrow: `${parseFloat(kpiRaw?.breakdownfrequencychange ?? 0) >= 0 ? "up" : "down"}`,
      absoluteChange: `${Math.abs(kpiRaw?.breakdownfrequencychange ?? 0)}%`,
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
      timeFrame: "this week",
      color: "#9ED3CC",
      hasStatus: true,
    },
    {
      title: "Equipment Owned",
      value: kpiRaw?.owned ?? 0,

      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
     color: "#9ED3CC",
    },
    {
      title: "Equipment Hired",
      value: kpiRaw?.hired ?? 0,
      iconColor: "#E0F0E4",
      dotColor: "#CE412D",
      textColor: "#377E36",
      status: null,
      color: "#9ED3CC",
    },
  ];

  return (
    <>
      <Grid2 container rowSpacing={1.25} columnSpacing={3} sx={{ mt: "20px" }}>
        <ProjectStatusOverviewHead
          lastModified={lastUpdated}
          marginBottm={"20px"}
        />

        {kpiData.map((kpi, index) => (
          <Grid2 key={index} size={{ xs: 12, md: 3, lg: 3 }}>
            <Card
              sx={{
                boxShadow: "none",
                border: "1px solid #25252517",
                borderRadius: "3px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ pl: "20px", pr: "20px", pt: "17px", pb: "17px" }}
              >
                <Box display="flex" alignItems="center" sx={{ mr: 0 }}>
                  <Typography
                    sx={{
                      bgcolor: kpi.color,
                      width: "45px",
                      height: "45px",
                      mr: 1,
                    }}
                  />
                  <Box>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="h6"
                        sx={{
                          letterSpacing: "-0.4px",
                          fontWeight: 700,
                          mr: 1,
                          lineHeight: "100%",
                          fontSize: "18px",
                          color: kpi.valueColor,
                        }}
                      >
                        {kpi.value}
                      </Typography>
                      {kpi.hasStatus && (
                        <Chip
                          label={kpi.absoluteChange}
                          size="small"
                          icon={
                            kpi.absoluteChange !== "0%" &&
                            // (kpi.arrow === "up" ? (
                            //   <ArrowUpward
                            //     sx={{
                            //       fontSize: "12px !important",
                            //       color: kpi.isPositive
                            //         ? `${kpi.textColor} !important`
                            //         : `${kpi.dotColor} !important`,
                            //     }}
                            //   />
                            // ) : (
                            //   <ArrowDownward
                            //     sx={{
                            //       fontSize: "12px !important",
                            //       color: kpi.isPositive
                            //         ? `${kpi.textColor} !important`
                            //         : `${kpi.dotColor} !important`,
                            //     }}
                            //   />
                            // ))
                            (
                              kpi.arrow === "up" ? (
                                <ArrowUpIcon
                                  style={{
                                    height: "12px",
                                    width: "12px",
                                    fill: kpi.isPositive ? kpi.textColor : kpi.dotColor,
                                  }}
                                />
                              ) : (
                                <ArrowDownIcon
                                  style={{
                                    height: "12px",
                                    width: "12px",
                                    fill: kpi.isPositive ? kpi.textColor : kpi.dotColor,
                                  }}
                                />
                              )
                            )

                          }
                          sx={{
                            backgroundColor: kpi.iconColor,
                            color:
                              kpi.isPositive === false
                                ? kpi.absoluteChange === "0%"
                                  ? kpi.textColor
                                  : kpi.dotColor
                                : kpi.textColor,
                            fontWeight: 500,
                            fontSize: "12px",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                      <Typography
                        variant="body2"
                        color="#474747"
                        sx={{
                          ml: "2px",
                          fontWeight: 400,
                          fontSize: "13px",
                          lineHeight: "24px",
                          letterSpacing: "-0.4px",
                          color: "#474747",
                        }}
                      >
                        {kpi.timeFrame}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: "5px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#252525",
                      }}
                    >
                      {kpi.title}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {kpi.status && (
                    <Avatar
                      sx={{
                        bgcolor: "#fff",
                        width: "37px",
                        height: "37px",
                        border: "1px solid #d3d3d3",
                      }}
                    >
                      {/* <MdOutlineArrowOutward
                        style={{
                          color: "#252525",
                          fontSize: "20px",
                          cursor: "pointer",
                          
                        }}
                        onClick={() => {
                          setPopupData(kpi);
                          setOpen(true);
                        }}
                      /> */}
                      <ArrowIcon
                        style={{
                          color: "#252525",
                          fontSize: "13px",
                          cursor: "pointer",
                          height: "13px",
                          stroke: "#252525",
                          strokeWidth: "6"

                        }}
                        onClick={() => {
                          setPopupData(kpi);
                          setOpen(true);
                        }}
                      />
                    </Avatar>
                  )}
                </Box>
              </Box>
            </Card>
          </Grid2>
        ))}
      </Grid2>

      {open && (
        <PMPopup
          title={popupData?.title}
          value={popupData?.value}
          status={popupData?.status}
          onOpen={open}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default ProgressKpiPM;
